import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, Skeleton } from 'antd';

export function LoadingSkeleton(): JSX.Element {
	return (
		<Row gutter={[16, 16]}>
			<Col xs={24}>
				<Form.Item labelCol={{ span: 24 }} label={I18n.get('Company')}>
					<Skeleton.Input block size="default" active />
				</Form.Item>
			</Col>
			<Col xs={24}>
				<Form.Item labelCol={{ span: 24 }} label={I18n.get('Industrial site')}>
					<Skeleton.Input block size="default" active />
				</Form.Item>
			</Col>
			<Col xs={24}>
				<Form.Item labelCol={{ span: 24 }} label={I18n.get('Sector')}>
					<Skeleton.Input block size="default" active />
				</Form.Item>
			</Col>
			<Col xs={24}>
				<Form.Item labelCol={{ span: 24 }} label={I18n.get('Cell')}>
					<Skeleton.Input block size="default" active />
				</Form.Item>
			</Col>
			<Col xs={24}>
				<Form.Item labelCol={{ span: 24 }} label={I18n.get('Workstation')}>
					<Skeleton.Input block size="default" active />
				</Form.Item>
			</Col>
		</Row>
	);
}
